import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzNoAnimationModule } from 'ng-zorro-antd/core/no-animation';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzTagModule } from 'ng-zorro-antd/tag';

import { LabelTextDrawerModule } from '@main-client/src/app/label-text-drawer/label-text-drawer.module';
import { ProgramScheduleFormModule } from '@main-client/src/app/program-schedule-form/program-schedule-form.module';
import { UploadModule } from '@main-client/src/app/upload/upload.module';

import { ProgramTemplateFormComponent } from './program-template-form.component';

import { EditLiveTranslationsModule } from '../edit-live-translations/edit-live-translations.module';

@NgModule({
  declarations: [ProgramTemplateFormComponent],
  exports: [ProgramTemplateFormComponent],
  imports: [
    CommonModule,
    EditLiveTranslationsModule,
    FlexLayoutModule,
    FormsModule,
    LabelTextDrawerModule,
    MatButtonModule,
    MatIconModule,
    MatRippleModule,
    NzButtonModule,
    NzFormModule,
    NzInputModule,
    NzNoAnimationModule,
    NzTagModule,
    ProgramScheduleFormModule,
    ReactiveFormsModule,
    UploadModule,
  ],
})
export class ProgramTemplateFormModule {}
